import { Card, Table } from 'antd';
import { useTopPayers } from './hooks/useTopPayers';
import { fmtCents } from './shared/formatCents';

export function TopPayersCard({
  customerId,
  year,
}: {
  customerId: string;
  year: number;
}) {
  const { data, isLoading } = useTopPayers(customerId, year);

  if (isLoading || !data) return <Card title="Top Payers" loading />;

  return (
    <Card title="Top Payers">
      <Table
        dataSource={data.payers}
        rowKey="payer"
        columns={[
          { title: 'Payer', dataIndex: 'payer', width: 220 },
          {
            title: 'Total',
            dataIndex: 'total',
            align: 'right' as const,
            width: 130,
            render: fmtCents,
          },
          {
            title: '# Deposits',
            dataIndex: 'transaction_count',
            align: 'right' as const,
            width: 130,
          },
        ]}
        pagination={false}
        size="small"
        scroll={{ x: 'max-content' }}
      />
    </Card>
  );
}
